// extracted by mini-css-extract-plugin
export var root = "JoinSection-module--root--fc7fb";